import { Model } from '../parents/model';

export class OrderItemModel extends Model {
  extentions = {};

  static ATTR_ID = 'id';
  static ATTR_ORDER_ID = 'order_id';
  static ATTR_PRODUCT_ID = 'product_id';
  static ATTR_PRODUCT_VARIATION_ID = 'product_variation_id';
  static ATTR_AMOUNT = 'amount';
  static ATTR_NAME = 'name';
  static ATTR_VARIATION_NAME = 'variation_name';
  static ATTR_BRAND_ID = 'brand_id';
  static ATTR_TAX_GROUP_ID = 'tax_group_id';
  static ATTR_DEFAULT_CATEGORY_ID = 'default_category_id';
  static ATTR_CODE = 'code';
  static ATTR_SKU = 'sku';
  static ATTR_EAN = 'ean';
  static ATTR_UPC = 'upc';
  static ATTR_JAN = 'jan';
  static ATTR_ISBN = 'isbn';
  static ATTR_MPN = 'mpn';
  static ATTR_POSITION = 'position';
  static ATTR_HEIGHT = 'height';
  static ATTR_WIDTH = 'width';
  static ATTR_DEPTH = 'depth';
  static ATTR_WEIGHT = 'weight';
  static ATTR_PRICE = 'price';
  static ATTR_TAXED_PRICE = 'taxed_price';
  static ATTR_UNIT_PRICE = 'unit_price';
  static ATTR_TAXED_UNIT_PRICE = 'taxed_unit_price';
  static ATTR_TOTAL_PRICE = 'total_price';
  static ATTR_TAXED_TOTAL_PRICE = 'taxed_total_price';
  static ATTR_TAX_RATE = 'tax_rate';

  /**
   * Extensions
   */
  static EXT_IMAGE = 'image';

  /**
   * Embeds
   */
  static EMBED_VARIATION_PROPERTIES_NAMES = 'variation_properties_names';

  get orderId() {
    return this.attributes[OrderItemModel.ATTR_ORDER_ID];
  }

  get productId() {
    return this.attributes[OrderItemModel.ATTR_PRODUCT_ID];
  }

  get productVariationId() {
    return this.attributes[OrderItemModel.ATTR_PRODUCT_VARIATION_ID];
  }

  get amount() {
    return this.attributes[OrderItemModel.ATTR_AMOUNT];
  }

  get name() {
    return this.attributes[OrderItemModel.ATTR_NAME];
  }

  get variationName() {
    return this.attributes[OrderItemModel.ATTR_VARIATION_NAME];
  }

  get brandId() {
    return this.attributes[OrderItemModel.ATTR_BRAND_ID];
  }

  get taxGroupId() {
    return this.attributes[OrderItemModel.ATTR_TAX_GROUP_ID];
  }

  get defaultCategoryId() {
    return this.attributes[OrderItemModel.ATTR_DEFAULT_CATEGORY_ID];
  }

  get code() {
    return this.attributes[OrderItemModel.ATTR_CODE];
  }

  get sku() {
    return this.attributes[OrderItemModel.ATTR_SKU];
  }

  get ean() {
    return this.attributes[OrderItemModel.ATTR_EAN];
  }

  get upc() {
    return this.attributes[OrderItemModel.ATTR_UPC];
  }

  get jan() {
    return this.attributes[OrderItemModel.ATTR_JAN];
  }

  get isbn() {
    return this.attributes[OrderItemModel.ATTR_ISBN];
  }

  get mpn() {
    return this.attributes[OrderItemModel.ATTR_MPN];
  }

  get position() {
    return this.attributes[OrderItemModel.ATTR_POSITION];
  }

  get height() {
    return this.attributes[OrderItemModel.ATTR_HEIGHT];
  }

  get width() {
    return this.attributes[OrderItemModel.ATTR_WIDTH];
  }

  get depth() {
    return this.attributes[OrderItemModel.ATTR_DEPTH];
  }

  get weight() {
    return this.attributes[OrderItemModel.ATTR_WEIGHT];
  }

  get price() {
    return this.attributes[OrderItemModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[OrderItemModel.ATTR_TAXED_PRICE];
  }

  get unitPrice() {
    return this.attributes[OrderItemModel.ATTR_UNIT_PRICE];
  }

  get taxedUnitPrice() {
    return this.attributes[OrderItemModel.ATTR_TAXED_UNIT_PRICE];
  }

  get totalPrice() {
    return this.attributes[OrderItemModel.ATTR_TOTAL_PRICE];
  }

  get taxedTotalPrice() {
    return this.attributes[OrderItemModel.ATTR_TAXED_TOTAL_PRICE];
  }

  get taxRate() {
    return this.attributes[OrderItemModel.ATTR_TAX_RATE];
  }

  get variationPropertiesNames() {
    return this.embeds[OrderItemModel.EMBED_VARIATION_PROPERTIES_NAMES];
  }

  get image() {
    return this.extentions[OrderItemModel.EXT_IMAGE];
  }

  /**
   * @param {Object} orderItemExtension
   */
  extendOrderItem(orderItemExtension) {
    this.extentions = { ...this.extentions, ...orderItemExtension };
  }
}
